import { atom } from "jotai";
import { nodesAtom } from "./nodesAtom";

export const selectedNodesAtom = atom((get) => {
  const nodes = get(nodesAtom);
  return nodes.filter((node) => node.selected);
});

selectedNodesAtom.debugLabel = "selectedNodesAtom";
